import { FiltroPesquisa } from "src/app/luds/componentes/painel2-pesquisa/painel2-pesquisa.component";
import { DataUtil } from "../util/data.util";


export class AtoLudConsulta {
    idAto: number;
	idTipoAto: number;
    idOrgao: number;
    numeroAto: string;    
    dataAtoStr: string | null;
    anoAto: string;
    texto: string;

    static fromFiltroPesquisa(filtroPesquisa: FiltroPesquisa): AtoLudConsulta {
        const atoLudConsulta = new AtoLudConsulta();
        atoLudConsulta.idAto = parseInt(filtroPesquisa.idAto);
        atoLudConsulta.idTipoAto = filtroPesquisa.tipoAto ? filtroPesquisa.tipoAto.idTipoAto : 0;
        atoLudConsulta.idOrgao = filtroPesquisa.orgao ? filtroPesquisa.orgao.idOrgao : 0;
        atoLudConsulta.numeroAto = filtroPesquisa.numeroAto;
        atoLudConsulta.dataAtoStr = filtroPesquisa.dataAto ? DataUtil.getDataStr(filtroPesquisa.dataAto) : null;
        atoLudConsulta.anoAto = filtroPesquisa.anoAto;
        atoLudConsulta.texto = filtroPesquisa.identificador;
        return atoLudConsulta;
    }
}